<template>
  <v-app>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :headers="headers"
      :items="items"
      :search="search"
      :loading="loading"
      loading-text="Đang tải dữ liệu... Vui lòng chờ"
      :items-per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :footer-props="{
        showFirstLastPage: true
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Nhật ký sử dụng</v-toolbar-title>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nhập từ khóa"
            single-line
            hide-details
            clearable
          />
          <v-spacer/>
          <v-menu 
            offset-y
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                text
                v-bind="attrs"
                v-on="on"
                class="mb-2 mr-2"
              >
                <v-icon class="mr-2">mdi-filter-variant-plus</v-icon>
                tìm nâng cao
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group
                v-model="filterSelected"
                multiple
              >
                <template v-for="(item, i) in filters">
                  <v-divider
                    v-if="!item"
                    :key="`divider-${i}`"
                  />

                  <v-list-item
                    v-else
                    :key="`item-${i}`"
                    :value="item"
                    active-class="deep-purple--text text--accent-4"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"/>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox
                          :input-value="active"
                          color="deep-purple accent-4"
                        />
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <Form 
            :showDialog="dialog" 
            :item="item" 
            @confirmed="onConfirmed" 
            @cancelled="onCancelled"
          />
        </v-toolbar>
        <v-toolbar
          v-if="filterSelected.length"
          flat
        >
          <v-sheet>
            <v-row>
              <v-col
                v-if="isInclude('typeLog')"
                cols="12"
                sm="auto"
              >
                <v-select
                  v-model="typeLog"
                  :items="typeLogs"
                  item-text="label"
                  item-value="value"
                  label="Loại"
                ></v-select>
              </v-col>
              <v-col
                v-if="isInclude('timeFrom')"
                cols="12"
                sm="auto"
              >
                <date-picker 
                  v-model="timeFrom"
                  :label="'Từ ngày'"
                >
                  <template slot="closed">
                    <v-btn
                      icon
                      @click="removeFilterItem('timeFrom')"
                      small
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </date-picker>
              </v-col>
              <v-col
                v-if="isInclude('timeTo')"
                cols="12"
                sm="auto"
              >
                <date-picker 
                  v-model="timeTo"
                  :label="'Đến ngày'"
                >
                  <template slot="closed">
                    <v-btn
                      icon
                      @click="removeFilterItem('timeTo')"
                      small
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </date-picker>
              </v-col>
            </v-row>
          </v-sheet>
        </v-toolbar>
      </template>
      <template v-slot:[`item.id`]="{ index }">
        {{ (perPage * (page-1)) +  (index+1) }}
      </template>
      <template v-slot:item.method="{ item }">
        <v-chip
          class="ma-2"
          label
        >
          {{ item.method }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          color="primary"
          @click="editItem(item)"
        >
          <v-icon>
            mdi-dots-horizontal
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Tải lại
        </v-btn>
      </template>
    </v-data-table>
  </v-app>
</template>
<script>
  import Form from '@/views/admin/users/log/Form';
  import DatePicker from '@/components/common/DatePicker.vue';
  import { mapActions } from 'vuex';
  export default {
    components: {
      Form,
      DatePicker
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      search: '',
      timeFrom: '',
      timeTo: '',
      typeLog: null,
      sortDesc: true,
      sortBy: "created_at",
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Tiêu đề', value: 'subject' },
        { text: 'Đường dẫn', value: 'url' },
        { text: 'Thao tác', value: 'method', align: 'center' },
        { text: 'Ip', value: 'ip' },
        { text: 'Thời gian', value: 'created_at' },
        { 
          align: 'right', 
          text: 'Chi tiết', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      items: [],
      editedIndex: -1,
      item: {},
      filters: [
        {
          key: 'typeLog',
          title: 'Loại'
        },
        {
          key: 'timeFrom',
          title: 'Từ ngày'
        },
        {
          key: 'timeTo',
          title: 'Đến ngày'
        }
      ],
      typeLogs: [
        { value: 'api', label: 'API' },
        { value: 'client', label: 'Client' }
      ],
      filterSelected: [],
      options: {},
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      anotherArrayName() {
        return this.filterSelected.map(item => item.key);
      },
      filteredItems() {
        return this.items.filter((i) => {
          return !this.filter_rs.type.ten_loai || (i.product_type.ten_loai === this.filter_rs.type.ten_loai);
        });
      }
    },
    watch: {
      dialog (val) {
        val || this.close();
      },
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      },
      timeFrom(){
        this.initialize();
      },
      timeTo(){
        this.initialize();
      },
      typeLog(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this; 
        const { page, itemsPerPage, sortBy, sortDesc } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            keyword: app.search,
            timeFrom: app.timeFrom,
            timeTo: app.timeTo,
            type: app.typeLog,
            sortDesc: sortDesc[0] ? 'desc' : 'asc',
            sortBy: sortBy[0] ? sortBy[0] : 'name'
          }
        };
        app.loading = true;
        axios.get("api/v1/activity-logs",request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            app.numberOfPages = response.data.to;
            app.page = response.data.current_page;
            app.perPage = response.data.per_page;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false;
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      isInclude(name) {
        return this.anotherArrayName.includes(name);
      },
      removeFilterItem(name){
        let index = this.filterSelected.indexOf(name);
        this.filterSelected.splice(index, 1);
      }
    }
  }
</script>